import { defineComponent as _defineComponent } from 'vue'
import { computed, getCurrentInstance } from 'vue'
import SkillDiagnosisBody from '@/components/aptitude/SkillDiagnosisBody.vue'
import {
  useSkillDiagnosisPopup,
  type SkillDiagnosisHost
} from '@/composables/aptitude/useSkillDiagnosisPopup'


export default /*#__PURE__*/_defineComponent({
  __name: 'SkillDiagnosisPopup',
  setup(__props) {

/**
 * 隠れスキル診断 UI。開閉は Pinia `useSkillDiagnosisPopupStore`。
 */
const instance = getCurrentInstance()
const host = computed(() => {
  const p = instance?.proxy as SkillDiagnosisHost | undefined
  return p || null
})

const {
  store,
  state,
  canDiagnose,
  insufficientMessage,
  result,
  errorMessage,
  hasResumeData,
  needsJobHistory,
  hidePopupFor10Days,
  showSkipOption,
  isYagiPrime,
  zoneDisplayName,
  closePopup,
  setVisible,
  runDiagnosis,
  resetToReady,
  openPaymentDialog
} = useSkillDiagnosisPopup(host)

return { __sfc: true,instance, host, store, state, canDiagnose, insufficientMessage, result, errorMessage, hasResumeData, needsJobHistory, hidePopupFor10Days, showSkipOption, isYagiPrime, zoneDisplayName, closePopup, setVisible, runDiagnosis, resetToReady, openPaymentDialog, SkillDiagnosisBody }
}

})